import React, { useState, useEffect } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import { ViewAboutSection } from "./SuperAdminViewDetailsPopupComponent/ViewAboutSection";
import { ViewHealthAndSanitation } from "./SuperAdminViewDetailsPopupComponent/ViewHealthAndSanitation";
import { ViewCuisineSection } from "./SuperAdminViewDetailsPopupComponent/ViewCuisineSection";
import { ViewSubscriptionSection } from "./SuperAdminViewDetailsPopupComponent/ViewSubscriptionSection";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import SuperAdminCall from "./SuperAdminCall";
import SuperAdminSMS from "./SuperAdminSMS";
import SuperAdminNotification from "./SuperAdminNotification";
import isEmpty from "../../../../store/validation/is-Empty";

export const SuperAdminVendorViewDetailsPopup = (props) => {
  const [showCall, seShowCall] = useState(false);
  const handleCloseCall = () => seShowCall(false);
  const handleShowCall = () => seShowCall(true);

  const [showTab, setShowTab] = useState("1");
  const handleTabChange = (e) => setShowTab(e);

  const profileCompleted = props.viewData.page_completed_till;
  const devided = profileCompleted && profileCompleted / 21;
  const finalValue = devided * 100;
  const percentage = Math.round(finalValue);

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3 action_icon_padding"
        onClick={handleShowCall}
      >
        <Image
          src={require("../../../../assets/images/ActionImages/image/view.svg")}
          alt="View Details"
          title="View Details"
          fluid
        />
      </Button>
      <Modal
        show={showCall}
        onHide={handleCloseCall}
        centered
        size="lg"
        className="admin_vendor_details_popup"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="modal_title_header">
            Merchant Profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-3 mb-5">
            <div className="col-5">
              <div className="d-flex align-items-center">
                <img
                  src={props.viewData.logo_url}
                  alt="Business Logo"
                  title="Business Logo"
                  className="profile_logo_img mr-3"
                />
                <div>
                  <p className="f18-700">{props.viewData.restaurant_name}</p>
                  <p className="font_20_m">Hours of Openings</p>
                  <p className="font_20_m">08:00 am to 10:00 pm</p>
                </div>
              </div>
            </div>
            <div className="col-4 text-center">
              <h4 className="f14-700 mb-2">Profile Completion</h4>
              <div className="progressCircleTbl">
                {/* <CircularProgressbar
                  value={66}
                  text={`66%`}
                  styles={buildStyles({
                    // This is in units relative to the 100x100px
                    // SVG viewbox.
                    pathColor: `#EE3A23`,
                    textColor: "#EE3A23",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                /> */}
                {/* <div style={{ width: 40 }}> */}
                <CircularProgressbar
                  value={percentage}
                  text={`${percentage}%`}
                  styles={buildStyles({
                    pathColor: `#FEC32D`,
                    textColor: "gray",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#3e98c7",
                  })}
                />
                {/* </div> */}
              </div>
              <p className="f10-400 text-red mt-2">Profile Completion</p>
            </div>
            <div className="col-3">
              <div className="d-flex justify-content-end">
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  onClick={props.handleShowFlag}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/forum.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>
                <SuperAdminCall />
              </div>
              <div className="d-flex justify-content-end mt-2">
                <SuperAdminSMS />
                <SuperAdminNotification />
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 d-flex justify-content-between">
              <div
                className={
                  showTab === "1"
                    ? "font_22_b c_red cursor"
                    : "font_22_m c_gray cursor"
                }
                onClick={(e) => handleTabChange("1")}
              >
                About
                {showTab === "1" ? (
                  <hr className="border_bottom_about" />
                ) : null}
              </div>
              <div
                className={
                  showTab === "2"
                    ? "font_22_b c_red cursor"
                    : "font_22_m c_gray cursor"
                }
                onClick={(e) => handleTabChange("2")}
              >
                Health and Sanitation
                {showTab === "2" ? (
                  <hr className="border_bottom_about" />
                ) : null}
              </div>
              <div
                className={
                  showTab === "3" ? "font_22_b c_red" : "font_22_m c_gray"
                }
                onClick={(e) => handleTabChange("3")}
              >
                Cuisine Setup
                {showTab === "3" ? (
                  <hr className="border_bottom_about" />
                ) : null}
              </div>
              <div
                className={
                  showTab === "4" ? "font_22_b c_red" : "font_22_m c_gray"
                }
                onClick={(e) => handleTabChange("4")}
              >
                Subscription
                {showTab === "4" ? (
                  <hr className="border_bottom_about" />
                ) : null}
              </div>
            </div>
          </div>
          {showTab === "1" && <ViewAboutSection data={props.viewData} />}
          {showTab === "2" && <ViewHealthAndSanitation data={props.viewData} />}
          {showTab === "3" && <ViewCuisineSection data={props.viewData} />}
          {showTab === "4" && <ViewSubscriptionSection data={props.viewData} />}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
//
